/*
 * @Descripttion: 创新产品
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-20 14:48:37
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-10-27 17:35:21
 */

const product = {
  skull: {
    processImg: require('@/assets/images/pc/innovate/skull_process.png'),
    m_processImg: require('@/assets/images/m/innovate/skull_process.png'),
    intelligence: {
      title: ['颅内动脉瘤智能诊疗产品'],
      des: ['颅内动脉瘤在人群中发生率高达7%，然而实际破裂风险仅为不到1%。治疗风险与破裂风险孰高孰低成为困扰临床医生的一大问题。脉流科技自主研发的颅内动脉瘤智能诊疗系列产品通过形态学、血流动力学以及临床数据，利用机器学习技术预测动脉瘤破裂风险、制定手术方案及术中实时规划等一系列产品，辅助医生完成诊疗关键环节，显著提升高风险动脉瘤早期检出率、提高治疗效果，降低死亡率与费用支出。'],
      img: require('@/assets/images/pc/innovate/skull_intelligence.png'),
      m_img: require('@/assets/images/m/innovate/skull_intelligence.png')
    },
    coreAdvantages: {
      title: '核心优势',
      des: ['<span class="fontW-3">100+</span>家合作单位，包括<span class="fontW-3">上海长海医院、上海华山医院、北京天坛医院、浙江医院</span>等', '<span class="fontW-3">100+</span>篇SCI文章发表，包括<span class="fontW-3">Stroke、AJNR、JNS</span>等著名脑血管病杂志', '<span class="fontW-3">几十</span>项科研项目的深度合作研究，大量文章和项目申请产出', '<span class="fontW-3">二十</span>多项合作申请的科研项目获批立项，包括<span class="fontW-3">十三五项目、国家自然面上、青年基金</span>等'],
      img: require('@/assets/images/pc/innovate/skull_advantages_bj.png'),
      list: [
        {
          title: '精准',
          des: '辅助医生提升诊断精度',
          img: require('@/assets/images/innovate/icons/6.png')
        }, {
          title: '安全',
          des: '可大幅提升介入手术效果',
          img: require('@/assets/images/innovate/icons/13.png')
        }, {
          title: '经济',
          des: '降低不必要耗材浪费及费用支出',
          img: require('@/assets/images/innovate/icons/9.png')
        }, {
          title: '个体化',
          des: '为患者和临床医生带来更好的诊疗体验',
          img: require('@/assets/images/innovate/icons/14.png')
        }
      ]
    },
    relatedProducts: {
      title: '相关产品',
      list: [
        {
          path: '/innovative/intracranial/aneuflow',
          title: 'AneuFlow-颅内动脉瘤辅助诊断系统',
          img: require('@/assets/images/innovate/aneuflow.png')
        }, {
          path: '/innovative/intracranial/aneuguide',
          title: 'AneuGuide-颅内动脉瘤实时手术规划系统',
          img: require('@/assets/images/innovate/aneuguide.png')
        }, {
          path: '/innovative/intracranial/aneushape',
          title: 'AneuShape-颅内动脉瘤微导管塑形产品',
          img: require('@/assets/images/innovate/aneushape.png')
        }, {
          path: '/innovative/intracranial/aneuplan',
          title: 'AneuPlan-颅内动脉瘤手术方案规划系统',
          img: require('@/assets/images/innovate/aneuplan.png')
        }
      ]
    },
    stroke: {
      title: '脑卒中诊断一站式产品',
      des: ['“脑卒中”俗称中风，是危害生命健康的“头号杀手”，脑卒中包括脑缺血和脑出血两个方面，是一种具有高发病率、高致残率、高死亡率和高复发率的脑血管疾病。脉流科技基于传统图像处理算法、机器学习算法推出脑卒中诊断一站式分析系统，辅助医生诊断，为临床治疗决策提供支撑。'],
      bjImg: require('@/assets/images/pc/innovate/skull_stroke.png'),
      bjImgM: require('@/assets/images/m/innovate/skull_stroke.png'),
      summary: {
        img: require('@/assets/images/pc/innovate/skull_stroke_summary.png'),
        des: [
          '智能 • 轻便 • 准确 • 实时提醒',
          '脑卒中诊断一站式解决方案',
          '解决超时间窗缺血性脑卒中评估难题，挽救患者生命'
        ]
      },
      list: [
        '诊、疗、研——全面提升科室战斗力',
        '覆盖全诊疗流程，提高手术安全性',
        '打造特色门诊，提高医院脑卒中门诊量',
        '辅助科室科研，参与多中心课题',
        '提升本院卒中中心知名度、美誉度',
        '匹配智慧医疗/智慧城市建设'
      ],
      products: {
        title: '相关产品',
        list: [
          {
            path: '/innovative/intracranial/accuaspects',
            title: 'AccuASPECTS-ASPECTS自动化评分系统',
            img: require('@/assets/images/innovate/accuaspects.png')
          }, {
            path: '/innovative/intracranial/accuctp',
            title: 'AccuCTP-颅内CT灌注影像自动化分析系统',
            img: require('@/assets/images/innovate/accuctp.png')
          }
        ]
      }
    },
    narrow: {
      title: ['颅内狭窄智能辅助诊疗产品'],
      des: '颅内动脉粥样硬化性疾病(Intracranialatheroscleroticdisease，ICAD）2年卒中复发率高达25％～30％，而中国有46％的卒中患者存在颅内动脉粥样硬化。目前筛选高风险的颅内大动脉ICAD狭窄病变时单纯依靠狭窄率高（≥70%)来判定，有研究显示40%的复发卒中发生在狭窄率为40%-69%的患者身上，而重度狭窄亦可因侧支循环开放降低卒中复发的风险，因此这就需要增加形态学以外的血管狭窄功能学评估方法。',
      bjImg: require('@/assets/images/pc/innovate/skull_narrow_bj.png'),
      MbjImg: require('@/assets/images/m/innovate/skull_narrow_bj.png'),
      summary: {
        img: require('@/assets/images/pc/innovate/skull_narrow_summary.png'),
        des: [
          '三维重构',
          '狭窄量化',
          '多维度功能学评估'
        ]
      },
      list: [
        '颅内动脉狭窄一站式分析系统具有强适应性，可对三维二维DSA、CTA、MRA颅脑医学图像进行三维重建，并结合患者个性化参数，计算得到参数，能够迅速准确地对术前和术后的颅内血管狭窄进行功能学评估。'
      ],
      products: {
        title: '相关产品',
        list: [
          {
            path: '/innovative/intracranial/accufficas',
            title: 'AccuFFicas-颅内动脉狭窄一站式评估系统',
            img: require('@/assets/images/innovate/accuffr_icas.png')
          }
        ]
      }
    }
  },
  heart: {
    processImg: require('@/assets/images/pc/innovate/heart_process.png'),
    m_processImg: require('@/assets/images/m/innovate/heart_process.png'),
    intelligence: {
      title: 'AccuFFR智能诊疗系列产品',
      des: '脉流科技推出基于冠脉CT、冠脉造影、IVUS、OCT多模态、多维度的FFR冠脉血管狭窄评估系列产品，覆盖冠心病智能、诊断、个性化诊疗流程，并应用深度学习进行创新，把运算效率大幅度提高，推动临床实现心血管疾病精准化、智能化的诊疗。',
      img: require('@/assets/images/pc/innovate/heart_intelligence.png'),
      m_img: require('@/assets/images/m/innovate/heart_intelligence.png')
    },
    coreAdvantages: {
      title: '产品获益',
      list: [
        {
          title: '患者',
          des: [
            '相比传统常规造影诊断准确度提高',
            '降低术后的主要心脏不良事件',
            '有利于患者的早期诊断和多次复查',
            '显著提高患者术后生命质量'
          ],
          img: require('@/assets/images/innovate/icons/heart_list_1.png')
        }, {
          title: '术者',
          des: [
            '可显著缩短射线时间',
            '提供直观的循证医学报告',
            '辅助完成更精准地冠脉介入治疗'
          ],
          img: require('@/assets/images/innovate/icons/heart_list_2.png')
        }, {
          title: '科室',
          des: [
            '无需使用任何耗材，降低耗占比',
            '无创功能学的冠脉介入标准质控',
            '人工智能和血流动力学顶尖的技术的临床运用'
          ],
          img: require('@/assets/images/innovate/icons/heart_list_3.png')
        }
      ]
    },
    relatedProducts: {
      title: '相关产品',
      list: [
        {
          path: '/innovative/intracardiac/accuffrct',
          title: 'AccuFFRct-基于CTA的无创FFR技术',
          img: require('@/assets/images/innovate/accuffr_ct.png')
        }, {
          path: '/innovative/intracardiac/accuffrangio',
          title: 'AccuFFRangio-基于冠脉造影的FFR技术',
          img: require('@/assets/images/innovate/accuffr_angio.png')
        }, {
          path: '/innovative/intracardiac/accuffrivus',
          title: 'AccuFFRivus-基于IVUS的FFR技术',
          img: require('@/assets/images/innovate/accuffr_ivus.png')
        }, {
          path: '/innovative/intracardiac/accuffroct',
          title: 'AccuFFRoct-基于OCT的FFR技术',
          img: require('@/assets/images/innovate/accuffr_oct.png')
        }
      ]
    },
    structureFunction: {
      title: '更多智能诊疗产品',
      des: '脉流科技心脏结构功能智能诊疗产品可基于CT影像的三维重建，自动完成心脏分割、冠脉分割、中心线提取、斑块检测及分型等心功能指数以及牛眼图分布，快速生成结构化报告，筛查出潜在心功能异常患者。以行业领先的高效率、全自动流程助力医生提升工作效率。',
      img: require('@/assets/images/innovate/heart_structureFunction.png'),
      bjImg: require('@/assets/images/innovate/heart_structureFunction_bj.png'),
      summary: {
        img: require('@/assets/images/pc/innovate/heart_structureFunction_summary.png'),
        imgM: require('@/assets/images/m/innovate/heart_structureFunction_summary.png'),
        bjImg: require('@/assets/images/innovate/heart_structureFunction_summary_bj.png')
      },
      products: {
        title: '相关产品',
        list: [
          {
            path: '/innovative/intracardiac/acculv',
            title: 'AccuLV-心脏无创功能学评估产品',
            img: require('@/assets/images/innovate/acculv.png')
          }, {
            path: '/innovative/intracardiac/accuimr',
            title: 'AccuIMR-微循环阻力评估系统',
            img: require('@/assets/images/innovate/accu_imr.png')
          // }, {
          //   path: '/innovative/intracardiac/accuvalve',
          //   title: 'AccuVALVE-心脏瓣膜手术规划',
          //   img: require('@/assets/images/innovate/accuvalve.png'),
          //   disabled: true
          }
        ]
      }
    },
    significance: {
      img: require('@/assets/images/pc/innovate/heart_significance.png'),
      imgM: require('@/assets/images/m/innovate/heart_significance.png')
    }
  },
  aneuflow: {
    title: '<i class="p-r-6">AneuFlow</i>系列-颅内动脉瘤辅助诊断系统',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuFlow',
    list: [
      {
        title: '临床应用',
        des: ['基于诊断成像生成的颅脑医学图像（包含三维DSA、CTA、MRA）进行三维重建，得到颅脑动脉瘤的3D模型，并结合形态学、血流动力学以及临床数据，为临床治疗诊断提供辅助。', 'AneuFlow目前已获批中国NMPA注册证。'],
        img: require('@/assets/images/innovate/AneuFlow/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '快速血流动力学计算',
            list: ['基于病人医学图像快速进行形态学和血流动力学计算', '可兼容不同的影像形态（包含三维DSA、CTA、MRA）']
          }, {
            title: '辅助诊断动脉瘤风险',
            list: ['提供丰富的血流动力学参数，辅助临床诊断', '不受过往7mm标准限制，更精准，临床金标准']
          }
        ],
        img: require('@/assets/images/innovate/AneuFlow/2.png')
      }, {
        title: '产品优势',
        des: [
          {
            title: 'NMPA获批注册',
            img: require('@/assets/images/innovate/AneuFlow/3.png')
          }, {
            title: '10分钟内完成分析',
            img: require('@/assets/images/innovate/AneuFlow/3.png')
          }, {
            title: '覆盖多种类型动脉瘤',
            img: require('@/assets/images/innovate/AneuFlow/3.png')
          }, {
            title: '超3000例动脉瘤血流动力学破裂风险评估数据库',
            img: require('@/assets/images/innovate/AneuFlow/3.png')
          }
        ],
        img1: require('@/assets/images/innovate/AneuFlow/3.png'),
        img2: require('@/assets/images/innovate/AneuFlow/4.png'),
        m_img1: require('@/assets/images/innovate/AneuFlow/m_4.png')
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Xiang J, Natarajan SK, Tremmel M, et al. Hemodynamic–Morphologic Discriminants for Intracranial Aneurysm Rupture. Stroke 2011; 42: 144–152.',
        'Xiang J, Yu J, Choi H, et al. Rupture Resemblance Score (RRS): toward risk stratification of unruptured intracranial aneurysms using hemodynamic–morphological discriminants. J NeuroIntervent Surg 2015; 7: 490–495.'
      ]
    }
  },
  aneuplan: {
    title: '<i class="p-r-6">AneuPlan</i>-颅内动脉瘤手术方案规划系统',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuPlan',
    list: [
      {
        title: '临床应用',
        des: ['基于重建的动脉瘤和载瘤动脉的三维模型以及形态学，选择尺寸合适的器械，根据具体病人的动脉瘤特征，通过流体力学计算不同治疗方案的血流改变，从而进行个性化手术预案，预期辅助临床决策。'],
        img: require('@/assets/images/innovate/AneuPlan/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '个体化精准治疗',
            list: ['适应多种诊疗场景，提供个性化治疗方案', '根据动脉瘤特征进行个性化手术预案', '提供精准化治疗', '助力降低手术风险，提高动脉瘤治疗的预后']
          }, {
            title: '独创多项专利技术应用',
            list: ['应用快速有限元方法进行虚拟治疗', '精准释放弹簧圈、支架以及密网支架', '提供FD、WEB装置等不同介入方案', '通过量化的血流动力学参数辅助临床决策']
          }
        ],
        img: require('@/assets/images/innovate/AneuPlan/2.png'),
        imgBj: require('@/assets/images/innovate/AneuPlan/3.png')
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Xiang J, Ma D, Snyder KV, Levy EI, Siddiqui AH, Meng H. Increasing Flow Diversion for Cerebral Aneurysm Treatment Using a Single Flow Diverter. Neurosurgery 2014; 75: 286–294.',
        'Xiang J, Damiano RJ, Lin N, et al. High-fidelity virtual stenting: modeling of flow diverter deployment for hemodynamic characterization of complex intracranial aneurysms. JNS 2015; 123: 832–840.',
        'Leng X, Wan H, Li G, et al. Hemodynamic effects of intracranial aneurysms from stent-induced straightening of parent vessels by stent-assisted coiling embolization. Interv Neuroradiol 2021; 27: 181–190.',
        'Zhang M, Tian Z, Zhang Y, et al. How to perform intra-aneurysmal coil embolization after Pipeline deployment: a study from a hemodynamic viewpoint. J Neurointerv Surg 2023; 15: 157–162.'
      ]
    }
  },
  aneuguide: {
    title: '<i class="p-r-6">AneuGuide</i>-颅内动脉瘤实时手术规划系统',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuGuide',
    list: [
      {
        title: '临床应用',
        des: ['基于颅内造影影像对动脉瘤及载瘤动脉进行快速三维重建，为动脉瘤介入手术提供密网支架模拟功能。AneuGuide提供双重三维可视化对比界面，贴壁性、金属覆盖率、孔密度三项参数量化分析等功能，直观高效地为临床提供密网支架选型参考。', 'AneuGuide获得中国NMPA创新医疗器械注册证及美国FDA 510(k)认证。'],
        img: require('@/assets/images/innovate/AneuGuide/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '快速精准的手术规划',
            list: ['密网支架长度预测精度达93.4% <span class="color_active">[1]</span>', '实时拖曳查看金属覆盖率、贴壁性、孔隙密度等重要参数变化', '3分钟完成分析，为动脉瘤介入手术提供密网支架模拟']
          }, {
            title: '独创虚拟仿真技术应用',
            list: ['独创虚拟仿真技术解决传统方法中耗时长，准确率低和无法准确定位等问题', '为密网支架型号选择和位置优化提供快速精准的解决方案', '提升介入手术效果，降低不必要耗材浪费及费用支出']
          }
        ],
        img: require('@/assets/images/innovate/AneuGuide/2.png'),
        imgBj: require('@/assets/images/innovate/AneuGuide/3.png')
      }, {
        title: '更多功能满足临床需求',
        des: [
          {
            des: '介入手术中实时指导支架放置位置、大小、选型、细微调整，临床高效工具',
            img: require('@/assets/images/innovate/AneuGuide/3_1.png')
          }, {
            des: '精确定位和选型，减少非必要的耗材浪费，辅助医生决策，降低盲目性操作',
            img: require('@/assets/images/innovate/AneuGuide/3_2.png')
          }, {
            des: '低风险，高效能，临床效果显著，助于患者减负，提升医生手术成功率',
            img: require('@/assets/images/innovate/AneuGuide/3_3.png')
          }
        ]
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Tong X, Shan Y, Leng X, et al. Predicting flow diverter sizing using the AneuGuide<sup>&trade;</sup> software: a validation study. J Neurointerv Surg 2023; 15: 57–62.'
      ]
    }
  },
  aneushape: {
    title: '<i class="p-r-6">AneuShape</i>-颅内动脉瘤微导管塑形产品',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuFlow',
    list: [
      {
        title: '临床应用',
        des: ['基于颅内血管造影图像重构出三维血管及动脉瘤模型，基于数学建模及图像算法，实现虚拟微导管路径的可视化，并与3D模型结合显示，最终根据微导管的回弹系数生成塑形针的形态，为神经介入医生在实施弹簧圈栓塞术过程中的微导管塑形提供解决方案。'],
        img: require('@/assets/images/innovate/AneuShape/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '广泛应用',
            list: ['广泛兼容各类微导管的回弹系数', '多角度三维立体塑形结果展示', '兼顾智能化治疗和个性化分析'],
            img: require('@/assets/images/innovate/AneuShape/2_1.png')
          }, {
            title: '快速精准',
            list: ['在3分钟内完成智能微导管塑形', '提供多种塑形参数，实现精准塑形', '多种塑形结果选择，优化治疗方案'],
            img: require('@/assets/images/innovate/AneuShape/2_2.png')
          }
        ],
        img: require('@/assets/images/innovate/AneuShape/2.png')
      }, {
        title: '快速完成智能微导管塑形',
        img: require('@/assets/images/innovate/AneuShape/3.png'),
        m_img: require('@/assets/images/innovate/AneuShape/m_3.png')
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Wu ZB, Zeng Y, Zhang HQ, et al. Virtual simulation with AneuShape<sup>&trade;</sup> software for microcatheter shaping of intracranial aneurysm coiling: a validation study. Frontiers in Neurology. 2023.'
      ]
    }
  },
  accuaspects: {
    title: '<i>AccuASPECTS -ASPECTS</i> 自动化评分系统',
    name: '脑血管智能诊疗解决方案',
    type: 'AccuASPECTS',
    list: [
      {
        title: '临床应用',
        des: ['AccuASPECTS可以接收平扫CT数据，对大脑自动进行分区，并识别每个分区是否发生缺血变化，自动化地计算ASPECTS评分。'],
        img: require('@/assets/images/innovate/AccuASPECTS/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '自动极速计算',
            list: ['依据平扫CT（NCCT）影像数据自动化计算ASPECTS评分', '自动校正运动偏差，对大脑分区并自动计算生成早期缺血变化'],
            img: require('@/assets/images/innovate/AccuASPECTS/2_1.png')
          }, {
            title: '快速评估',
            list: ['缺血性脑卒中需要争分夺秒的诊断和治疗来避免病情迅速恶化', '相比于人工阅图耗时来判断每个区域进行评估', '迅速对患者大脑中动脉（MCA）供血区域进行自动化评分'],
            img: require('@/assets/images/innovate/AccuASPECTS/2_2.png')
          }, {
            title: '独家机器学习算法技术支持',
            list: ['由于影像设备、患者状况的差异和阅图人员的主观性，人工阅图的方法缺乏稳定性', 'AccuASPECTS系统能够摒弃主观干扰输出稳定的结果'],
            img: require('@/assets/images/innovate/AccuASPECTS/2_3.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuASPECTS/2.png')
      }, {
        title: '实际病例医生标注结果和软件自动结果对比',
        des: [''],
        img: require('@/assets/images/innovate/AccuASPECTS/3.png')
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Wan S, Lu W, Fu Y, et al. Automated Calculation of the Alberta Stroke Program Early CT Score based on Large Cohort of Data and Machine Learning. European Radiology 2023.'
      ]
    }
  },
  accuctp: {
    title: '<i class="p-r-6">AccuCTP</i>系列-颅内<i>CT</i> 灌注影像自动化分析系统',
    name: '脑血管智能诊疗解决方案',
    type: 'AccuCTP',
    list: [
      {
        title: '临床应用',
        des: ['AccuCTP基于CT灌注影像生成CBF、CBV、MTT和Tmax等灌注参数，并基于参数计算确定梗死核心和缺血半暗区的体积，同时提供多维度，多阈值的参数，辅助临床诊断。', '全球首个同时获批中国NMPA医疗器械注册证和美国FDA510(k)的CTP产品。'],
        img: require('@/assets/images/innovate/AccuCTP/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '高效分析',
            list: ['2分钟内完成分析，有效提高脑卒中诊断效率', '完全自动化计算，传输与发送分析报告', '实时串联影像分析与临床治疗'],
            img: require('@/assets/images/innovate/AccuCTP/icon1.png')
          }, {
            title: '智能评估',
            list: ['量化评估结果准确率达90%', '打破传统阅片模式，定量分析脑组织缺血情况', '关注“半暗带”改善患者预后'],
            img: require('@/assets/images/innovate/AccuCTP/icon2.png')
          }, {
            title: '广泛应用',
            list: ['提供标准可视化交互界面', '兼顾自动化流程与个性化分析', '实现临床应用与科研一体'],
            img: require('@/assets/images/innovate/AccuCTP/icon3.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuCTP/2.png')
      }, {
        title: '基于颅内CT灌注影像处理软件',
        img: require('@/assets/images/innovate/AccuCTP/3.png')
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Lu W, Yao F, Yin C, et al. Assessment of Parameter Maps and Ischemic  Volumes with Different CT Perfusion Software：A Comparative Study. Neuroradiology 2023.'
      ]
    }
  },
  accufficas: {
    title: '<i class="p-r-6">AccuFFicas</i>系列-颅内动脉狭窄一站式评估系统',
    name: '脑血管智能诊疗解决方案',
    type: 'AccuFFicas',
    list: [
      {
        title: '临床应用',
        des: ['基于符合DICOM3.0标准的二维颅内DSA影像进行血管三维重构，根据血管的形态学信息，运用血流动力学方法分析血管内血流分数FF值变化。', 'AccuICAS获美国FDA 510(k)注册证，是全球首个获得批准的颅内狭窄功能学评估产品。'],
        img: require('@/assets/images/innovate/AccuFFicas/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '广泛应用',
            list: ['强适应性，可对三维二维DSA、CTA、MRA进行三维重建', '强操作性，可视化精准显示病变位置与狭窄程度'],
            img: require('@/assets/images/innovate/AccuFFicas/icon1.png')
          }, {
            title: '快速实时',
            list: ['5分钟完成分析，快速精准', '自动完成从诊断到出报告的全流程'],
            img: require('@/assets/images/innovate/AccuFFicas/icon2.png')
          }, {
            title: '精准评估',
            list: ['基于CTA、DSA影像进行三维重建，个性化治疗，得出FF参数，判断血管狭窄程度，提供临床依据', '精准动脉狭窄与粥样硬化评估，专为应对中国人高发动脉狭窄问题，提供精准诊断解决方案。'],
            img: require('@/assets/images/innovate/AccuFFicas/icon3.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFicas/2.png')
      }, {
        title: '精准动脉狭窄与粥样硬化评估',
        img1: require('@/assets/images/innovate/AccuFFicas/3_1.png'),
        img2: require('@/assets/images/innovate/AccuFFicas/3_2.png'),
        m_imgDes: '专为应对中国人高发动脉狭窄问题，提供精准诊断解决方案。'
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Wang M, Leng X, Wu J, et al. Cerebral Fractional Flow Reserve for Functional Evaluation of Intracranial Atherosclerotic Stenosis. Transl Stroke Res 2022; published online May 30.',
        'Wang M, Leng X, Mao B, et al. Functional evaluation of intracranial atherosclerotic stenosis by pressure ratio measurements. Heliyon 2023; 9: e13527.',
        'Yang P, Wan S, Wang J, et al. Hemodynamic Assessment for Intracranial Atherosclerosis from Angiographic Images: A Clinical Validation Study. J Neurointerv Surg 2023.'
      ]
    }
  },
  accuffrct: {
    title: '<i class="p-r-6">AccuFFRct</i>系列-基于CTA的无创FFR技术',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFRct',
    list: [
      {
        title: '临床应用',
        des: [
          'CTA功能学分析系统是基于人工智能和血流动力学的冠脉功能学评估分析产品，基于冠脉CTA影像进行冠脉重构，根据病人的生理信息和血流动力学计算获得评估冠状动脉功能性狭窄的参数。',
          '区别于传统的FFR有创检测方法，基于CTA的FFR技术产品采用自主研发的快速血流计算模型，能够快速、精准地计算整个冠脉树的FFR，快速筛查出潜在心梗病人。',
          'AccuFFRct目前已获批中国NMPA和欧洲CE注册证。'
        ],
        img: require('@/assets/images/innovate/AccuFFRct/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: ['深度学习应用于冠脉重建'],
            list: ['全自动完成冠脉影像智能图像后处理', '3分钟完成分析，快速精准，应用AI进行冠脉树提取速度20秒'],
            img: require('@/assets/images/innovate/AccuFFRct/2_1.png')
          }, {
            title: ['快速血流动力学计算'],
            list: ['与有创FFR检测结果对比，评估准确率<span class="nowrap">91.8%<span class="color_active">[1]</span></span>', '无需数据离开诊疗场所，可现场获取报告结果'],
            img: require('@/assets/images/innovate/AccuFFRct/2_2.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRct/2.png')
      }, {
        title: '产品优势',
        des: [
          {
            title: '精准无创',
            list: ['钙化、灰区病例准确率高', '基于无创检测技术快速完成筛查，无需使用腺苷/ATP等血管扩张药物'],
            img: require('@/assets/images/innovate/icons/6_big.png')
          }, {
            title: '快速高效',
            list: ['可快速返回报告', '根据临床需求快速同步获取报告结果'],
            img: require('@/assets/images/innovate/icons/7_big.png')
          }, {
            title: '全面完整',
            list: ['精准的三维仿真和血流动力学分析', '仅需无创CTA DICOM 可获取冠脉血管任一位点的FFR值'],
            img: require('@/assets/images/innovate/icons/8_big.png')
          }, {
            title: '经济安全',
            list: ['常规CTA检查，无额外辐射、无痛苦', '减少有创检查费用，避免不必要的干预治疗'],
            img: require('@/assets/images/innovate/icons/9_big.png')
          }
        ]
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Jiang J, Du C, Hu Y, et al. Diagnostic performance of computational fluid dynamics (CFD)-based fractional flow reserve (FFR) derived from coronary computed tomographic angiography (CCTA) for assessing functional severity of coronary lesions. Quant Imaging Med Surg 2023; 13: 1672–85.',
        'Zhang J, Xu K, Hu Y, et al. Diagnostic performance of deep learning and computational fluid dynamics-based instantaneous wave-free ratio derived from computed tomography angiography. BMC Cardiovasc Disord 2022; 22: 33.',
        'Jiang W, Pan Y, Hu Y, et al. Diagnostic accuracy of coronary computed tomography angiography-derived fractional flow reserve. Biomed Eng Online 2021; 20: 77.'
      ]
    }
  },
  accuffrangio: {
    title: '<i class="p-r-6">AccuFFRangio</i>系列-基于冠脉造影的FFR技术',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFRangio',
    list: [
      {
        title: '临床应用',
        des: ['基于冠脉造影的无导丝冠脉功能学评估系统，可通过导管室造影机采集到的两个角度的血管造影影像，进行目标血管的快速三维重建和血流储备分数计算，快速精准对心肌缺血程度进行定量分析，指导冠脉介入精准治疗。', 'AccuFFRangio目前已同时获得中国NMPA、美国FDA和欧洲CE三重认证。'],
        img: require('@/assets/images/innovate/AccuFFRangio/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: ['术前功能学精准评估'],
            list: ['无需任何耗材通过造影图即可诊断目标血管缺血程度', '通过狭窄云图等功能辅助临床诊断罪犯病变', '全自动血流速度计算辅助临床判断TIMI血流分级', '一站式评估冠脉大血管及微循环问题，辅助临床诊断'],
            img: require('@/assets/images/innovate/icons/10.png')
          }, {
            title: ['术中PCI手术精准规划'],
            list: ['可预测治疗后冠脉功能学结果', '可模拟支架近远端落脚点', '建议支架长度、直径选择'],
            img: require('@/assets/images/innovate/icons/11.png')
          }, {
            title: ['术后疗效精准确认'],
            list: ['可对比术前术后功能学指标', '可导出循证医学报告辅助临床医患沟通', '评估术后微循环风险，辅助预后管理'],
            img: require('@/assets/images/innovate/icons/12.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRangio/2.png'),
        m_img: require('@/assets/images/innovate/AccuFFRangio/m_2.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '节约时间和成本',
            list: ['2分钟输出结果，提升临床诊断效率', '无导丝，无需使用腺苷/ATP，可操作性强', '实时在线分析，FFR检查时间缩短80%', '敏感性较固定Pa值高32.5%'],
            img: require('@/assets/images/innovate/icons/9_big.png')
          }, {
            title: '便捷的诊断方式',
            list: ['可输出直观彩色的功能学报告', '可个性化添加医疗机构信息和临床诊断意见', '操作简单、安全、高效、直观的工作流程', '临床效果好，医院获得医疗技术背书'],
            img: require('@/assets/images/innovate/icons/7_big.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRangio/3.png'),
        imgDes: '准确性超过95.72%，开创FFR检测的无导丝时代'
      }, {
        title: '更多功能满足临床需求',
        des: [
          '基于冠脉造影影像进行无导丝快速定量分析心肌缺血程度FFR',
          '创新技术革新传统温度/压力导丝使用方式，显著减轻病患痛苦并降低成本，助力提升医疗普及率',
          '突破形态学评估局限，摒弃低准确度和低重复性的诊断评估'
        ]
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Li C, Leng X, He J, et al. Diagnostic Performance of Angiography-Based Fractional Flow Reserve for Functional Evaluation of Coronary Artery Stenosis. Front Cardiovasc Med 2021; 8: 714077.',
        'Jiang J, Tang L, Du C, et al. Diagnostic performance of AccuFFRangio in the functional assessment of coronary stenosis compared with pressure wire-derived fractional flow reserve. Quant Imaging Med Surg 2022; 12: 949–58.'
      ]
    }
  },
  accuffrivus: {
    title: '<i class="p-r-6">AccuFFR</i><i>ivus</i>-冠脉IVUS影像功能学分析系统',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFRIVUS',
    list: [
      {
        title: '临床应用',
        des: ['AccuFFRivus是基于导管室造影机采集的血管造影影像融合患者的血管内超声（IVUS）影像，以无导丝的方式计算血流储备分数，以此来定量评估患者冠脉功能性狭窄。'],
        img: require('@/assets/images/innovate/AccuFFRivus/1.png')
      }, {
        title: '产品特性',
        img: require('@/assets/images/innovate/AccuFFRivus/2.png'),
        m_img: require('@/assets/images/innovate/AccuFFRivus/m_2.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: ['高精度自动分割管腔'],
            list: ['使用DeepIVUS技术进行高精度自动分割管腔', 'IVUS管腔分割精度达到0.937', '辅助临床医生高效进行冠状动脉壁与斑块分析'],
            img: require('@/assets/images/innovate/AccuFFRivus/icon1.png')
          }, {
            title: ['深度学习应用于IVUS图像重建'],
            list: ['运用独创的深度学习IVUS神经分割网络进行计算分析结果准确率达到了96%<span class="color_active">[1]</span>', '一次IVUS测量即可同时获得FFR功能学评估', '解决血管内超声诊断和功能学评估需二次耗材收费昂贵的问题'],
            img: require('@/assets/images/innovate/AccuFFRivus/icon2.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRivus/2.png'),
        m_img: require('@/assets/images/innovate/AccuFFRivus/m_2.png')
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Jiang J, Feng L, Li C, et al. Fractional flow reserve for coronary stenosis assessment derived from fusion of intravascular ultrasound and X-ray angiography. Quant Imaging Med Surg 2021; 11: 4543–55.',
        'Dong L, Jiang W, Lu W, et al. Automatic segmentation of coronary lumen and external elastic membrane in intravascular ultrasound images using 8-layer U-Net. Biomed Eng Online 2021; 20: 16.'
      ]
    }
  },
  accuffroct: {
    title: '<i class="p-r-6">AccuFFRoct</i>系列-冠脉OCT影像功能学分析系统',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFROCT',
    list: [
      {
        title: '临床应用',
        des: ['AccuFFRoct是基于导管室造影机采集的血管造影影像融合患者的光学相干断层显像（OCT）影像，以无导丝的方式计算血流储备分数，以此来定量评估患者冠脉功能性狭窄的软件。', 'AccuOCT目前已获批中国NMPA注册证。'],
        img: require('@/assets/images/innovate/AccuFFRoct/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: '高精度、多模态的三维重建',
            list: ['结合OCT影像和造影影像对病变血管管腔进行三维重建', '快速精准地为医生提供病变血管及参考血管的数值', '不断提高其自身的诊断效能 ，提高临床诊断效率'],
            img: require('@/assets/images/innovate/AccuFFRoct/2.png')
          }, {
            title: '腔内影像OCT结合血管造影影像',
            list: ['一次OCT测量即可同时获得腔内影像数据和功能学评估指标', '解决血管OCT诊断和血管功能学诊断须二次耗材收费昂贵的问题'],
            img: require('@/assets/images/innovate/AccuFFRoct/3.png')
          }
        ]
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Pan W, Wei W, Hu M, et al. Diagnostic accuracy of a novel optical coherence tomography based fractional flow reserve algorithm for assessment of coronary stenosis significance. Cardiology Journal 2023.'
      ]
    }
  },
  acculv: {
    title: '<i class="p-r-14">AccuLV</i>-心脏无创功能学评估产品',
    m_title: '<i class="p-r-6">AccuLV</i>-心脏无创功能学评估产品',
    name: '心血管智能诊疗解决方案',
    type: 'AccuLV',
    list: [
      {
        title: '临床应用',
        des: ['基于人工智能的全自动心脏功能学评估分析系统AccuLV可对冠脉CTA影像进行左心室的分割，并根据分割结果输出心脏各时相的左心室舒张末期容积、左心室收缩末期容积，协助输出计算射血分数（EF）并生成左心室内外膜等信息，辅助临床诊断心脏功能。'],
        img: require('@/assets/images/innovate/AccuLV/1.png')
      }, {
        title: '产品特性',
        des: [
          {
            title: ['应用深度学习进行心脏CT分割'],
            list: ['综合图像处理和深度学习等人工智能技术，实现高精度、高性能分割', 'LV分割上DSC达到0.927，为医生进行诊断和治疗时提供更精准的心功能参数计算'],
            img: require('@/assets/images/innovate/AccuLV/2_1.png')
          }, {
            title: ['冠脉影像学结合功能学评估'],
            list: ['采用脉流自主研发的左心室Al分割技术，快速、精准地建立左心室三维模型', '计算心功能指数同时生成牛眼图，快速筛查出潜在的心功能异常患者'],
            img: require('@/assets/images/innovate/AccuLV/2_2.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuLV/2.png')
      }, {
        title: '产品优势',
        des: [
          {
            title: '高效',
            list: ['AI分析，2分钟内完成计算'],
            img: require('@/assets/images/innovate/icons/7_big.png')
          }, {
            title: '精准',
            list: ['AI左心室分割准确性高达93.8%<span class="color_active">[1]</span>'],
            img: require('@/assets/images/innovate/icons/6_big.png')
          }, {
            title: '经济',
            list: ['冠脉CT造影（CCTA）无创、成本低、检查时间较短'],
            img: require('@/assets/images/innovate/icons/9_big.png')
          }, {
            title: '智能',
            list: ['全自动AI分割，处理速度快，可重复性高'],
            img: require('@/assets/images/innovate/icons/15_big.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuLV/3.png'),
        imgDes: 'AccuLV牛眼图'
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Li C, Song X, Zhao H, et al. An 8-layer residual U-Net with deep supervision for segmentation of the left ventricle in cardiac CT angiography. Comput Methods Programs Biomed 2021; 200: 105876.'
      ]
    }
  },
  accuimr: {
    title: '<i class="p-r-5">AccuIMR</i>',
    des: ['-基于冠脉造影的微循环阻力评估系统'],
    name: '心血管智能诊疗解决方案',
    type: 'AccuIMR',
    list: [
      {
        title: '临床应用',
        des: ['基于冠脉造影的冠脉微循环功能学评估系统，可通过两个角度的常规冠脉造影影像，快速重建目标血管三维模型并计算对应血管的远端的微循环阻力系数，定量精准评估患者微循环障碍，指导患者诊疗策略。', '2023年1月获批进入国家三类创新医疗器械绿色通道。'],
        img: require('@/assets/images/innovate/AccuIMR/1.png')
      }, {
        title: '产品优势',
        des: [
          {
            title: '节约时间成本',
            list: [['无需使用压力导丝等耗材'], ['仅需常规冠脉造影数据'], ['5分钟完成计算评估'], ['提高临床诊断效率']]
          }, {
            title: '便捷的综合性诊断',
            list: [['简单清晰安全的半自动化工作流'], ['可输出直观明晰的功能学评估报告'], ['可配合AccuFFRangio系统，一站式', '评估冠脉大血管及微循环小血管的功能学状况']]
          }
        ],
        img: require('@/assets/images/innovate/AccuIMR/2.png'),
        img1: require('@/assets/images/innovate/AccuIMR/2_1.png')
      }, {
        title: '临床验证',
        list: [
          {
            title: '准确性',
            num: 93.83,
            unit: '%'
          }, {
            title: '敏感性',
            num: 93.65,
            unit: '%'
          }, {
            title: '特异性',
            num: 92.31,
            unit: '%'
          }
        ],
        des: 'AccuIMR具有很好的诊断性能和可用性，可为医生提供一种准确、定量的微循环功能学评估指标，在当前以FFR为主的冠心病诊疗管理策略中，加强患者的临床风险分层和管理，改善患者预后。'
      }
    ],
    article: {
      title: '相关文献：',
      des: [
        'Fan Y, Li C, Hu Y, et al. Angiography-Based Index of Microcirculatory Resistance (AccuIMR) for the Assessment of Microvascular Dysfunction in Acute Coronary Syndromes and Chronic Coronary Syndromes. Quant Imaging Med Surg 2023.'
      ]
    }
  },
  accuvalve: {
    title: '',
    name: '心血管智能诊疗解决方案',
    type: 'AccuVALVE'
  }
}

export default product
